import { render, staticRenderFns } from "./MyShareCode.vue?vue&type=template&id=0a496fcc&scoped=true"
import script from "./MyShareCode.vue?vue&type=script&lang=js"
export * from "./MyShareCode.vue?vue&type=script&lang=js"
import style0 from "./MyShareCode.vue?vue&type=style&index=0&id=0a496fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a496fcc",
  null
  
)

export default component.exports